import { Component } from '@angular/core';
import { HoldingsComponent } from './holdings.component';

@Component({
  selector: 'eid-holdings-desktop',
  templateUrl: './holdings.desktop.component.html',
  styleUrls: ['./holdings.desktop.component.scss']
})
export class HoldingsDesktopComponent extends HoldingsComponent {}
